module.exports = __webpack_public_path__ + "img/history8.3d7088aa.jpg";